<template>
  <vx-card :title="title">
    <vs-row>
      <vs-col>
        <vs-tabs>
          <vs-tab label="Sync Control">
            <datatable-sync-control
              ref="datatable-sync-control"
            ></datatable-sync-control>
          </vs-tab>
        </vs-tabs>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
import DatatableSyncControl from "./_components/datatable-sync-control.vue";

export default {
  components: {
    DatatableSyncControl,
  },
  data() {
    return {
      title: "Monitoring Dashboard ETL",
    };
  },
  mounted() {},
  methods: {},
};
</script>
